import Vue from 'vue';
import { mapActions } from 'vuex'

Vue.prototype.tiempoInactividad = 1800000;
let tiempo; // Declarar la variable tiempo

const InactivityLogout = {
  // Crear un mixin global
    created: function () {
      window.onload = this.resetearTiempo;
      document.onmousemove = this.resetearTiempo;
      document.onkeydown  = this.resetearTiempo;
    },
    methods: {
      ...mapActions(["logout"]),
      resetearTiempo: function() {
        clearTimeout(tiempo);
        tiempo = setTimeout(this.logout, Vue.prototype.tiempoInactividad);
      },
    }
  
}

export default InactivityLogout;